import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  type: null,
};

export const isQATypeSlice = createSlice({
  name: "qaType",
  initialState,
  reducers: {
    setQA: (state, actions) => {
      state.type = actions.payload;
    },
  },
});

export const { setQA } = isQATypeSlice.actions;

export default isQATypeSlice.reducer;
